import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { submit } from 'redux-form'
import NProgress from 'nprogress'

import { Modal } from 'Components/Modal'
import { ModalBody } from 'Components/Modal/ModalBody'
import { ModalFooter } from 'Components/Modal/ModalFooter'
import { ModalHeader } from 'Components/Modal/ModalHeader'
import { ModalTitle } from 'Components/Modal/ModalTitle'

import { AddConversionReportForm } from 'Containers/Form/Campaigns/AddConversionReport'
import { CONFIRM_POPUP_MESSAGE } from './constants'
import {
  addConversionReport,
  getCampaigns,
  uploadConversionReport,
} from 'Reducers/Campaigns/actions'
import { showReduxModal } from '../../../../Reducers/UI/actions'
import { Table, Td, Tr, Th } from '../../../../Components/Table'
import { getReadbleDateTimeString } from '../../../../shared/libraries/utils/date'
import { STATUS_CAMPAIGN_ARCHIVE } from '../../../../shared/constants'
import SubmitButton from '../../../../Components/Form/SubmitButton/index'
import { splitArrayIntoChunks } from '../../../../shared/libraries/utils/array'
import { apiClient } from '../../../../Module/API/Client'

const formName = 'add-conversion-report-form'

class AddConversionReportModal extends React.Component {
  state = {
    campaignId: null,
    progress: null,
  }

  componentDidMount() {
    if (this.props.modalShow) {
      const { getCampaigns } = this.props
      getCampaigns({ statuses: 'ACTIVE' })
    }
    window.onbeforeunload = event => {
      if (this.state.progress && this.state.progress < 100) {
        const closeMessage = CONFIRM_POPUP_MESSAGE
        event.returnValue = closeMessage
        return closeMessage
      }
      return null
    }
  }

  render() {
    const uploadInProgress = this.state.progress && this.state.progress < 100

    return (
      <Modal show={this.props.modalShow}>
        <ModalHeader>
          <ModalTitle>Import Conversion Report</ModalTitle>
        </ModalHeader>
        <ModalBody>
          <AddConversionReportForm
            initiallySelectedCampaign={this.props.initiallySelectedCampaign}
            campaigns={this.props.campaigns}
            form={formName}
            progress={this.state.progress}
            onSubmit={this.addConversionReportFormSubmitHandler}
          />
        </ModalBody>
        <ModalFooter>
          <SubmitButton
            value="cancel"
            onClick={this.modalCancelHandler}
            disabled={uploadInProgress}
          />
          <SubmitButton
            value={uploadInProgress ? 'Uploading...' : 'Confirm'}
            onClick={this.modalConfirmHandler}
            disabled={uploadInProgress}
          />
        </ModalFooter>
      </Modal>
    )
  }

  modalCancelHandler = () => {
    const { modalCancelButtonHandler } = this.props
    if (!this.state.progress) modalCancelButtonHandler()
  }

  modalConfirmHandler = () => {
    const { submitForm } = this.props
    if (!this.state.progress) submitForm(formName)
  }

  addConversionReportFormSubmitHandler = values => {
    this.addConversionReport(values)
  }
  renderErrorModalBody = rawErrors => {
    const errors = rawErrors.map(error => {
      const {
        timestamp,
        previousTotalResults,
        metricName,
        flyerCode,
        totalResults,
      } = error
      return {
        flyerCode,
        metricName,
        message: (
          <p style={{ padding: '8px 0' }}>
            At the timestamp{' '}
            <span className="bold">{getReadbleDateTimeString(timestamp)}</span>{' '}
            there's already been{' '}
            <span className="bold">
              {previousTotalResults} {metricName}
            </span>{' '}
            conversions for flyer code <span className="bold">{flyerCode}</span>{' '}
            therefor we can't update the total to be{' '}
            <span className="bold">{totalResults}</span> which is less.
          </p>
        ),
      }
    })
    return (
      <section style={{ maxHeight: 460, overflow: 'scroll' }}>
        <Table>
          <thead>
            {Object.keys(errors[0]).map(heading => (
              <Th>{heading}</Th>
            ))}
          </thead>
          <tbody>
            {errors.map(errorData => (
              <Tr>
                {Object.values(errorData).map(item => (
                  <Td>{item}</Td>
                ))}
              </Tr>
            ))}
          </tbody>
        </Table>
      </section>
    )
  }
  addConversionReport = values => {
    // Work around for now as this is not hooked up at all but we just want
    // to indicate that something is happening
    var hillFunction = x => x / (x + 3000)
    var timeStart = new Date()
    var updateProgress = () => {
      var timeElapsed = new Date() - timeStart
      this.setState({ progress: hillFunction(timeElapsed) * 100 })
    }
    var interval = setInterval(updateProgress, 50)

    const { modalSubmitSuccessHandler } = this.props
    const callbacks = {
      onSuccess: (...args) => {
        clearInterval(interval)
        this.setState({ progress: null })
        modalSubmitSuccessHandler(...args)
      },
      onError: errors => {
        const { showReduxModal } = this.props
        clearInterval(interval)
        this.setState({ progress: null })
        showReduxModal({
          title: 'Data Conflicts',
          children: this.renderErrorModalBody(errors),
          hideCancel: true,
          confirmLabel: 'OK',
        })
      },
      stopLoading: () => {
        clearInterval(interval)
        this.setState({ progress: null })
      },
    }

    const reader = new FileReader()
    reader.addEventListener('load', async function() {
      const divider = '\r\n'
      const data = Buffer.from(this.result.split(',')[1], 'base64').toString(
        'ascii',
      )
      const dataArr = data.split(divider)
      const headers = dataArr.shift()

      const chunks = splitArrayIntoChunks({
        inputArray: dataArr,
        itemsPerChunk: 200,
      })
      NProgress.start()

      let results = []

      for (let index = 0; index < chunks.length; index++) {
        const chunk = chunks[index]
        const payload = {
          report_url: '',
          report_data: [headers, ...chunk].join(divider),
        }

        const req = await apiClient.addConversionReport(
          values.campaign_id,
          payload,
        )

        const res = await req.json()

        results.push(res)
      }

      const collectedData = results.reduce(
        (acc, res) => {
          acc.errors = [...acc.errors, ...res.errors]
          acc.inputs = [...acc.inputs, ...res.inputs]
          acc.results = [...acc.results, ...res.results]
          if (!res.success) {
            acc.success = res.success
          }
          return acc
        },
        { errors: [], inputs: [], results: [], success: true },
      )

      NProgress.done()

      if (collectedData.success) {
        callbacks.onSuccess(collectedData)
      } else {
        callbacks.stopLoading()
      }
      if (collectedData.errors && collectedData.errors.length > 0) {
        callbacks.onError(collectedData.errors)
      }
    })
    reader.readAsDataURL(values.report[0])
  }
}

AddConversionReportModal.propTypes = {
  addConversionReport: PropTypes.func.isRequired,
  campaigns: PropTypes.array.isRequired,
  getCampaigns: PropTypes.func.isRequired,
  modalShow: PropTypes.bool.isRequired,
  modalSubmitSuccessHandler: PropTypes.func.isRequired,
  modalCancelButtonHandler: PropTypes.func.isRequired,
  submitForm: PropTypes.func.isRequired,
  uploadConversionReport: PropTypes.func.isRequired,
  initiallySelectedCampaign: PropTypes.string,
  showReduxModal: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
  campaigns: state.campaigns.activeCampaignsList.filter(
    c => c.status != STATUS_CAMPAIGN_ARCHIVE,
  ),
})

const mapDispatchToProps = {
  addConversionReport,
  getCampaigns,
  submitForm: submit,
  uploadConversionReport,
  showReduxModal,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddConversionReportModal)



// WEBPACK FOOTER //
// ./src/Containers/Header/Modals/AddConversionModal/index.js